import * as C from "../constants";
import { createReducer } from "../utils/misc";

const initialState = {
    logs: {
        data: "",
        isLoading: false,
        isLoaded: false,
    },
    machineLogs: {
        data: "",
        machineId: null,
        isLoaded: false,
        isLoading: false,
    }
};

export default createReducer(initialState, {
    [C.GET_LOGS_REQUEST]: (state) => ({
        ...state,
        logs: {
            ...state.logs,
            isLoading: true
        },
    }),
    [C.GET_LOGS_FAILURE]: (state) => ({
        ...state,
        logs: {
            ...state.logs,
            isLoaded: false,
            isLoading: false,
        },
    }),
    [C.GET_LOGS_SUCCESS]: (state, payload) => ({
        ...state,
        logs: {
            ...state.machineLogs,
            data: payload,
            isLoaded: true,
            isLoading: false,
        }
    }),
})


// WEBPACK FOOTER //
// ./src/reducers/logs.js